import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupProfileAction } from '../markupProfile.action';
import { MarkupProfileTranslator } from '../markupProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const loadMarkupProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.load.started),
  mergeMap((params) => {
    return dependencies.api.getMarkupProfile(params).pipe(
      mergeMap((response) => {
        const result = MarkupProfileTranslator.fromApiDetails(response);

        return [
          MarkupProfileAction.load.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          MarkupProfileAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
